export default __webpack_public_path__ + "static/media/scrabble-1024w.09298b0e.webp";